import {type NavigateOptions, type To, useNavigate} from "react-router-dom";
import {buildPreservedUrl} from "./preserved-params";

/**
 * Drop-in replacement for useNavigate that appends preserved
 * marketing/tracking params and Cookiebot hash to every navigation.
 */
export function usePreservedNavigate() {
    const navigate = useNavigate();

    return (to: To | number, options?: NavigateOptions) => {
        if (typeof to === "number") {
            navigate(to);
        } else if (typeof to === "string") {
            navigate(buildPreservedUrl(to), options);
        } else {
            const pathname = to.pathname ?? "";
            const preserved = buildPreservedUrl(
                pathname + (to.search ? `?${to.search}` : "") + (to.hash ? `#${to.hash}` : "")
            );
            navigate(preserved, options);
        }
    };
}
